import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Client} from "../../models/client.model";
import {VetClinic} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {IonSearchbar, ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {PartnerProduct} from "../../models/partner-product.model";
import {PartnerProductService} from "../../providers/partner-product.service";

@Component({
  selector: 'app-partner-product-search',
  templateUrl: './partner-product-search.component.html',
  styleUrls: ['./partner-product-search.component.scss'],
})
export class PartnerProductSearchComponent implements OnInit, OnDestroy {


  @Input()
  title: string;

  @Input()
  partnerId: string;

  @Input()
  nameToFind: string;


  chosenItem: PartnerProduct | null = null;
  partnerProductsSub: Subscription;
  isBusySub: Subscription;


  items: PartnerProduct[];
  @ViewChild('search') search: IonSearchbar;


  private isBusy: boolean;
  isLoading: boolean = false;

  constructor(private modalController: ModalController,
              private partnerProductService: PartnerProductService,
              private commonUtils: CommonUtils,
              private appStateService: AppStateService) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }


  ionViewDidEnter() {
    if (this.search) {
      this.search.setFocus();
    }
  }

  prepareFoundItems() {
    if (this.nameToFind.length >= 3) {
      console.log('Name to find', this.nameToFind);
      this.appStateService.updateIsBusySubject(true);
      this.isLoading = true;
      this.partnerProductsSub = this.partnerProductService.searchForProductByPhrase(this.nameToFind, this.partnerId).subscribe(products => {
        if (products) {
          console.log(products);
          this.items = products;
        }
        this.isLoading = false;
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.isLoading = false;
        switch (error.message) {
          case 'PARNTER_PRODUCT_NOT_FOUNDS':
            this.commonUtils.presentAlertToast('Nie znaleziono produktów');
            this.appStateService.updateIsBusySubject(false);
            break;
          default:
            this.commonUtils.presentAlertToast('Wystąpił błąd');
            this.appStateService.updateIsBusySubject(false);
        }
      });
    }

  }

  onItemChosen(item: PartnerProduct) {
    this.chosenItem = item;
    this.modalController.dismiss(this.chosenItem, 'confirm');
  }

  getItemName(item) {
    return item.name;
  }


  ngOnDestroy() {
    if (this.partnerProductsSub) {
      this.partnerProductsSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }

  }
}
